import React, { useEffect, useState } from "react";
import {
  ContentContainer,
  Expander,
  ICON_PROPS,
  IconButton,
  MainContentContainer,
  ObjectItem,
  ObjectList,
  ObjectListHeader,
} from "@riag-libs/etax-pattern-library";
import { FontIcon, Text } from "@fluentui/react";
import HttpService from "../../services/HttpService";
import { useNavigate } from "react-router-dom";
import { useBoolean } from "@fluentui/react-hooks";
import { VonMirGeteiltPanel } from "../Panel/VonMirGeteiltPanel";
import { NothingSharedMessage } from "./NothingSharedMessage";

function VonMirGeteilt() {
  const [acceptedInvitations, setAcceptedInvitations] = useState([]);
  const [selectedItem, setSelectedItem] = useState({});
  const [selectedGroup, setSelectedGroup] = useState({});
  const navigate = useNavigate();
  const [
    isSharingOpen,
    { setTrue: openSharingPanel, setFalse: dismissSharingPanel },
  ] = useBoolean(false);

  const getAcceptedInvitationsList = async () => {
    const response = await HttpService.getAxiosClient().post(
      "/api/shares/my/all",
      {
        lang: "de",
      }
    );
    if (response.status === 200) {
      setAcceptedInvitations(response.data);
    }
  };

  useEffect(() => {
    getAcceptedInvitationsList();
  }, []);

  const handleInvitationDelete = async (invitation) => {
    try {
      const response = await HttpService.getAxiosClient().post(
        "/api/shares/my/delete",
        {
          subjectId: invitation.subjectId,
          subjectType: invitation.type,
          trusteeId: invitation.trustee.userId,
        }
      );
      if (response.status === 200) {
        getAcceptedInvitationsList();
      }
    } catch (error) {
      console.log(error, error.message);
    }
  };

  const displayAcceptedInvitations = (invitationGroups) => {
    return invitationGroups.map((group) => (
      <Expander
        key={group.trustee.userId}
        title={`${group.trustee.fname} ${group.trustee.lname}`}
        headerTitleTag="h3"
        headerTitleTagClass="title3"
        headerTitleSize="l-fb-40"
        className="formContent"
        headerContent={
          <>
            <ContentContainer
              size="l-fb-50 l-flex-nogrow"
              className="horizontal"
            >
              <Text as="span" className="flexItem t-listText hiddenLabel">
                E-Mail:
              </Text>
              <Text as="span" className="flexItem t-listText t-right-s">
                {group.trustee.email}
              </Text>
            </ContentContainer>
            <ContentContainer
              size="l-fb-40 l-flex-nogrow"
              className="horizontal"
            >
              <Text as="span" className="flexItem t-listText hiddenLabel">
                Mobile-Nummer:
              </Text>
              <Text as="span" className="flexItem t-listText t-right-s">
                {group.trustee.mobile}
              </Text>
            </ContentContainer>
            <ContentContainer
              size="l-fb-10 l-flex-nogrow"
              className="horizontal"
            >
              <Text as="span" className="flexItem t-listText hiddenLabel">
                Anzahl geteilt:
              </Text>
              <Text as="span" className="flexItem t-listText t-right">
                {group.shares.length}
              </Text>
            </ContentContainer>
          </>
        }
        headerContentSize="l-fb-60"
      >
        <ObjectList
          title="Geteilter Inhalt"
          headingTag="h4"
          headingTagClass="title4"
          listHeader={
            <ObjectListHeader hasActionButton={true}>
              <Text as="span" className="flexItem t-listHeading l-fb-30">
                Mandant
              </Text>
              <Text as="span" className="flexItem t-listHeading l-fb-10">
                PID
              </Text>
              <Text as="span" className="flexItem t-listHeading l-fb-30">
                Typ
              </Text>
              <Text as="span" className="flexItem t-listHeading l-fb-30">
                Benutzerrechte
              </Text>
            </ObjectListHeader>
          }
        >
          {group.shares.map((invitation, index) => (
            <ObjectItem
              key={invitation.subjectId || index}
              onClick={() => navigate(`/mandanten/${invitation.pid}`)}
              ariaLabel={invitation.name}
              actionButton={
                <IconButton
                  iconProps={ICON_PROPS.DeleteIcon}
                  ariaLabel="Teilen beenden"
                  onClick={() => handleInvitationDelete(invitation)}
                  className="moreIcon"
                />
              }
            >
              <ContentContainer className="l-flex-rowgap-8">
                <ContentContainer size="l-fb-30" className="horizontal">
                  <FontIcon
                    iconName={
                      invitation.subjectType === "JP"
                        ? ICON_PROPS.JPIcon.iconName
                        : ICON_PROPS.NPIcon.iconName
                    }
                    className="objectItemIcon-large"
                  />
                  <Text as="span" className="flexItem title3">
                    {invitation.name}
                  </Text>
                </ContentContainer>
                <ContentContainer size="l-fb-10" className="horizontal">
                  <Text as="span" className="flexItem t-listText hiddenLabel">
                    PID:
                  </Text>
                  <Text as="span" className="flexItem t-listText t-right-s">
                    {invitation.pid}
                  </Text>
                </ContentContainer>
                <ContentContainer size="l-fb-30" className="horizontal">
                  <Text
                    as="span"
                    className="flexItem t-listText hiddenLabel l-fb-100"
                  >
                    Typ:
                  </Text>
                  <Text as="span" className="flexItem t-listText t-right-s">
                    {invitation.typeDescr} {invitation.year}
                  </Text>
                </ContentContainer>
                <ContentContainer size="l-fb-30" className="horizontal">
                  <Text
                    as="span"
                    className="flexItem t-listText hiddenLabel l-fb-100"
                  >
                    Benutzerrechte:
                  </Text>
                  <Text as="span" className="flexItem t-listText t-right-s">
                    {invitation.permissions.accountsView === true &&
                      "Sieht Steuerkonto, Sieht Dokumente"}
                    {invitation.permissions.declRead === true &&
                      "Deklaration lesen, bearbeiten, einreichen"}
                  </Text>
                </ContentContainer>
              </ContentContainer>
            </ObjectItem>
          ))}
        </ObjectList>
      </Expander>
    ));
  };

  if (acceptedInvitations.length === 0) {
    return <NothingSharedMessage type={"vonmir"} />;
  }

  return (
    <MainContentContainer>
      <ObjectList
        title="Von mir geteilt mit"
        headingTag="h2"
        headingTagClass="title2"
        listHeader={
          <ObjectListHeader>
            <ContentContainer className="flexItem l-fb-40">
              <Text as="span" className="t-listHeading l-m-l-32">
                Name
              </Text>
            </ContentContainer>
            <ContentContainer className="flextItem l-flex-align-end l-fb-60">
              <Text as="span" className="flexItem t-listHeading l-fb-50">
                E-Mail
              </Text>
              <Text as="span" className="flexItem t-listHeading l-fb-40">
                Mobile-Nummer
              </Text>
              <Text
                as="span"
                className="flexItem t-listHeading t-right l-fb-10"
              >
                Anzahl geteilt
              </Text>
            </ContentContainer>
          </ObjectListHeader>
        }
      >
        {acceptedInvitations && displayAcceptedInvitations(acceptedInvitations)}
      </ObjectList>
      <VonMirGeteiltPanel
        isOpen={isSharingOpen}
        onDismiss={dismissSharingPanel}
        selectedGroup={selectedGroup}
        selectedItem={selectedItem}
        setAcceptedInvitations={setAcceptedInvitations}
      />
    </MainContentContainer>
  );
}

export default VonMirGeteilt;
